import { IFieldDefinitionLogic } from '../../../interfaces/ifield-definition-logic.interface';
import { TextMetadataFieldDefLogic } from './text-metadata-field-def-logic';

export class FormTemplateNameFieldDefinitionLogic extends TextMetadataFieldDefLogic implements IFieldDefinitionLogic {
    // Constructor.
    public constructor() {
        super('formInstanceId');
    }

    public get canParticipateInFlexFieldBehavior(): boolean {
        return true;
    }

    public get isNonFlexFieldButCanParticipateInFlexFieldBehavior(): boolean {
        return true;
    }

    /*
    public telerikFilterControlComparisonOperators(): string[] {
        return ["neq", "eq", "gt" , "gte" , "lt" , "lte"];        
    }
    */
}
